import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { InstitutionDetailsUpdateProvider } from '@/features/institution/context/update';
import { useInstitutionOnboardingIneligiblePath } from '@/features/institution/hooks/useInstitutionOnboardingIneligiblePath';
import { useProfileInstitutionDetailsDraft } from '@/hooks/queries/use-profile-institution-details';
import LoadingPage from '@/pages/loading';

// There is no draft once the record is on the latest version, including straight after the update replaces it
const InstitutionOnboardingUpdateGuard = () => {
  const location = useLocation();
  const { isLoading, data: draft } = useProfileInstitutionDetailsDraft();
  const ineligiblePath = useInstitutionOnboardingIneligiblePath('/institution/onboarding/update', draft?.answers);

  if (isLoading) return <LoadingPage />;

  if (!draft) return <Navigate to="/institution/onboarding" replace />;

  // The eligibility guard only sees the live record, so a jurisdiction chosen in the draft is held here
  if (ineligiblePath && location.pathname !== ineligiblePath) return <Navigate to={ineligiblePath} replace />;

  return (
    <InstitutionDetailsUpdateProvider>
      <Outlet />
    </InstitutionDetailsUpdateProvider>
  );
};
InstitutionOnboardingUpdateGuard.displayName = 'InstitutionOnboardingUpdateGuard';

export default InstitutionOnboardingUpdateGuard;
